import React from 'react';
import ExplainSection from './ExplainSection';

const QuestionExplainWrapper = ({ question }) => {
  if (!question) {
    return null;
  }

  const questionData = {
    id: question.id,
    title: question.question,
    question: question.question,
    topic: question.topic,
    category: question.category,
    subCategory1: question.subCategory1,
    subCategory2: question.subCategory2,
    answer: question.answer,
    extraInfo: question.extraInfo,
  };

  return <ExplainSection questionData={questionData} />;
};

export default QuestionExplainWrapper;
